export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_200.7e644e80.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};